import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { DOWNLOAD_CSV_TEMPLATE, UPLOAD_CSV } from "../../appConstants";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import "../Modal/Modal.css";
import "./Modal.css";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Multiselect from "multiselect-react-dropdown";
import { fetchRouterConfigs } from "./Utility";
import { DICOM_MODALITIES } from "../../DropdownConstants";

const FetchStudiesModal = (props) => {
  const [error, seterror] = useState();
  const [selectedModality, setselectedModality] = useState("");
  const [operation, setOperation] = useState("CGET");
  const [cFindChecked, setcFindChecked] = useState(false);
  const [CSVDownloadStatus, setCSVDownloadStatus] = useState(false);
  const [CSVUploadStatus, setCSVUploadStatus] = useState(false);
  const [uniqueIdentifier, setUniqueIdentifier] = useState("");
  const [file, setFile] = useState();
  const [routerConfig, setRouterConfig] = useState();
  const [currentRouterConfig, setCurrentRouterConfig] = useState();
  const uniqueIdentifierChange = (e) => {
    // console.log(e);
    setUniqueIdentifier(e);
  };

  const modalStyles = {
    color: "white",
    fontWeight: "bold",
    position: "absolute",
    top: 0,
    right: 0,
    width: "30%",
    padding: "2rem",
    height: "100vh",
    backdropFilter: "blur(14.5px)",
    background: "transparent",
    boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
  };

  const uniqueIdentifierOptions = [
    {
      id: 1,
      value: "accession_number",
      label: "Accession Number",
    },
    {
      id: 2,
      value: "study_id",
      label: "Study Instance UID",
    },
  ];

  useEffect(() => {
    const result = async () => {
      const configResponse = await fetchRouterConfigs();
      setRouterConfig(configResponse?.data?.items);
    };
    result();
  }, []);

  const RouterConfigOptions = routerConfig?.map((item) => ({
    id: item.id,
    value: item.id,
    label: item.config_name,
  }));

  function handleFileUpload(event) {
    setFile(event.target.files[0]);
    // console.log(event.target.files[0]);
    setCSVUploadStatus(true);
  }

  const routerConfigChange = (e) => {
    setCurrentRouterConfig(e);
  };

  const handleSubmit = async () => {
    if (cFindChecked && !selectedModality) {
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 3000);

      return;
    }
    let modalities = selectedModality
      ? selectedModality && selectedModality.map((item) => item.value)
      : [];
    const formData = new FormData();
    formData.append("file", file);
    formData.append(
      "router_config_id",
      currentRouterConfig && currentRouterConfig.value
    );
    formData.append("operation", operation);

    if (modalities.length === 0) {
      formData.append("allowed_modality", "[]");
    } else {
      formData.append("allowed_modality", JSON.stringify(modalities));
    }

    try {
      const response = await axiosInstance.post(`${UPLOAD_CSV}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      });
      // console.log(response);
      if (response.data.success) {
        toast.success(`${response.data.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        props.handleClose();
      } else {
        toast.error(`Error: ${response.data.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const downloadCSVTemplate = async () => {
    try {
      const response = await axiosInstance.get(
        `${DOWNLOAD_CSV_TEMPLATE}?unique_identifier=${uniqueIdentifier.label}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        }
      );
      // console.log(response);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "template.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      setCSVDownloadStatus(true);
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const uploadCSV = async () => {
    var input_button = document.getElementById("upload_csv_input");
    input_button.click();
  };

  const onSelect = (selectedList) => {
    var dummyarray = [];
    selectedList.map((items) => {
      dummyarray.push({
        value: items.value,
        label: items.label,
      });
    });
    setselectedModality(dummyarray);
  };
  const onRemove = (selectedList) => {
    var dummyarray = [];
    selectedList.map((items) => {
      dummyarray.push({
        value: items.value,
        label: items.label,
      });
    });
    setselectedModality(dummyarray);
  };

  const handleFetchTypeChange = (event) => {
    setOperation(event.target.value);
  };
  const handleCFindChange = (event) => {
    setcFindChecked(event.target.checked);
  };

  return (
    <div>
      <Modal
        className="Backdrop"
        open={props.ModalState}
        onClose={props.handleClose}
        sx={{ width: "300", background: "transparent" }}
      >
        <Box sx={modalStyles}>
          <div className="d-flex justify-content-between align-items-center">
            <div className="h5 font-weight-bold  mt-2">QR Studies</div>
            <IconButton
              className="text-light"
              onClick={props.handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="mt-3 rounded">
            <div className="mt-3">
              <div className="sort_search_header_field">Unique Identifier*</div>
              <Select
                placeholder="Select Unique Identifier"
                name="unique_identifier"
                options={uniqueIdentifierOptions}
                onChange={uniqueIdentifierChange}
                value={uniqueIdentifier}
                isClearable={true}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: "5px",
                  colors: {
                    ...theme.colors,
                    primary75: "white",
                    primary50: "white",
                    primary25: "white",
                    danger: "#DE350B",
                    dangerLight: "#FFBDAD",
                    neutral0: "black",
                    neutral5: "hsl(0, 0%, 95%)",
                    neutral10: "hsl(0, 0%, 90%)",
                    neutral20: "hsl(0, 0%, 80%)",
                    neutral30: "hsl(0, 0%, 70%)",
                    neutral40: "hsl(0, 0%, 60%)",
                    neutral50: "hsl(0, 0%, 50%)",
                    neutral60: "hsl(0, 0%, 40%)",
                    neutral70: "hsl(0, 0%, 30%)",
                    neutral80: "white",
                    neutral90: "hsl(0, 0%, 10%)",
                  },
                })}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    width: "100%",
                    backgroundColor: "black", // Set the background color to black
                    color: "white",
                    zIndex: 9999,
                    border: "1px solid #0f9077",
                    boxShadow: "0 0 1px rgba(0, 0, 0, 0)",
                    "&:hover": {
                      border: "1px solid #0f9077",
                    },
                  }),

                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: "black", // Set the background color to black
                    color: "white",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    fontWeight: "normal", // Make the placeholder text normal
                  }),
                }}
              />
            </div>
            {!uniqueIdentifier && (
              <div
                className="mt-1 text-center"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <button
                  className="btn-class"
                  style={{
                    backgroundColor: "rgb(91 91 91 / 70%)",
                    cursor: "default",
                  }}
                >
                  Download CSV Template
                </button>
              </div>
            )}
            {uniqueIdentifier && (
              <div
                className="mt-1 text-center"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <button
                  className="btn-class"
                  onClick={() => downloadCSVTemplate()}
                >
                  Download CSV Template
                </button>
              </div>
            )}
            {/* {uniqueIdentifier && (
              <div
                className="mt-1 text-center"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <button
                  className="btn-class"
                  style={{
                    backgroundColor: "rgb(91 91 91 / 70%)",
                    cursor: "default",
                  }}
                >
                  Upload CSV
                </button>
              </div>
            )} */}
            {uniqueIdentifier && (
              <div
                className="mt-1 text-center"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <input
                  type={"file"}
                  accept={".csv"}
                  style={{ display: "none" }}
                  id="upload_csv_input"
                  onChange={handleFileUpload}
                />
                <button className="btn-class" onClick={() => uploadCSV(true)}>
                  Upload CSV
                </button>
                {file && (
                  <div
                    style={{
                      fontSize: "15px",
                      fontWeight: "100",
                      paddingTop: "10px",
                      paddingLeft: "5px",
                    }}
                  >
                    {file.name}
                  </div>
                )}
              </div>
            )}
            <div className="mt-3">
              <div className="sort_search_header_field">Router Config</div>
              <Select
                placeholder="Select Router Config"
                name="RouterConfig"
                options={RouterConfigOptions}
                onChange={routerConfigChange}
                isClearable={true}
                value={currentRouterConfig}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: "5px",
                  colors: {
                    ...theme.colors,
                    primary75: "white",
                    primary50: "white",
                    primary25: "white",
                    danger: "#DE350B",
                    dangerLight: "#FFBDAD",
                    neutral0: "grey",
                    neutral5: "hsl(0, 0%, 95%)",
                    neutral10: "hsl(0, 0%, 90%)",
                    neutral20: "hsl(0, 0%, 80%)",
                    neutral30: "hsl(0, 0%, 70%)",
                    neutral40: "hsl(0, 0%, 60%)",
                    neutral50: "hsl(0, 0%, 50%)",
                    neutral60: "hsl(0, 0%, 40%)",
                    neutral70: "hsl(0, 0%, 30%)",
                    neutral80: "white",
                    neutral90: "hsl(0, 0%, 10%)",
                  },
                })}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    width: "100%",
                    backgroundColor: "black",
                    color: "white",
                    border: "1px solid #0f9077",
                    boxShadow: "none",
                    "&:hover": {
                      border: "1px solid #0f9077",
                    },
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: "black",
                    color: "white",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  clearIndicator: (provided) => ({
                    ...provided,
                    cursor: "pointer",
                  }),
                }}
              />
            </div>
            <div className="d-flex flex-column">
              <div className="fetch-type">
                <FormControl>
                  <FormLabel
                    className="label-fields"
                    id="demo-row-radio-buttons-group-label"
                  >
                    Fetch Type
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={operation}
                    onChange={handleFetchTypeChange}
                  >
                    <FormControlLabel
                      value="CGET"
                      control={<Radio />}
                      label="C-GET"
                    />
                    <FormControlLabel
                      value="CMOVE"
                      control={<Radio />}
                      label="C-MOVE"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="c-find">
                <div
                  className="d-flex justify-content-start align-items-center"
                  style={{ marginLeft: "-12px" }}
                >
                  <div>
                    <Checkbox
                      checked={cFindChecked}
                      onChange={handleCFindChange}
                    />
                  </div>
                  <div>C-FIND</div>
                </div>
              </div>
              <div className="c-find-options">
                <div className="d-flex justify-content-between flex-column align-items-start">
                  {cFindChecked && (
                    <>
                      <div className="label-fields">Modality</div>
                      <Multiselect
                        options={DICOM_MODALITIES}
                        className="mt-1"
                        displayValue="label"
                        style={{
                          chips: { background: "black", fontWeight: "normal" },
                          multiselectContainer: {
                            background: "#121C1B",
                            border: "1px solid #0f9077",
                            borderRadius: "5px",
                            outline: "none",
                            width: "23rem",
                          },
                          searchBox: {
                            border: "none",
                          },
                          option: {
                            background: "black",
                            color: "#FFFFFF",
                            fontWeight: "normal",
                          },
                        }}
                        onSelect={onSelect}
                        onRemove={onRemove}
                        selectedValues={selectedModality}
                      />
                    </>
                  )}
                </div>
              </div>
              {cFindChecked && error && (
                <div className="errorStyles">Modality is required</div>
              )}
            </div>

            <div className="mt-1 text-center">
              {CSVUploadStatus && currentRouterConfig ? (
                <button className="btn-class" onClick={(e) => handleSubmit(e)}>
                  SUBMIT
                </button>
              ) : (
                <button
                  className="btn-class"
                  style={{
                    backgroundColor: "rgb(91 91 91 / 70%)",
                    cursor: "disabled",
                  }}
                  // onClick={(e) => handleSubmit(e)}
                  disabled
                >
                  SUBMIT
                </button>
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};
export default FetchStudiesModal;
